import { Injectable, signal } from '@angular/core';

export type AppTheme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly currentTheme = signal<AppTheme>('light');

  constructor() {
    this.applyTheme('light');
  }

  toggleTheme(): void {
    const nextTheme: AppTheme =
      this.currentTheme() === 'light' ? 'dark' : 'light';

    this.setTheme(nextTheme);
  }

  setTheme(theme: AppTheme): void {
    this.currentTheme.set(theme);
    this.applyTheme(theme);
  }

  forceLightTheme(): void {
    this.setTheme('light');
  }

  private applyTheme(theme: AppTheme): void {
    document.body.classList.toggle('dark-theme', theme === 'dark');
  }
}